import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__plus",
  "use": "general__plus-usage",
  "viewBox": "0 0 11 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 10\" id=\"general__plus\">\n    <path d=\"M5.5.5A.5.5 0 0 1 6 1v3.5h3.5a.5.5 0 1 1 0 1H6V9a.5.5 0 1 1-1 0V5.499L1.5 5.5a.5.5 0 0 1 0-1L5 4.499V1a.5.5 0 0 1 .5-.5Z\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol